import { render } from "./AddReglementModal.vue?vue&type=template&id=267c9fba&ts=true"
import script from "./AddReglementModal.vue?vue&type=script&lang=ts"
export * from "./AddReglementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__